import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HospitalStateService } from './hospitalstate.service';

export interface HospitalAddOns {
  readonly ipd: boolean;
  readonly pharmacy: boolean;
}

interface HospitalAddOnSource {
  isIPD?: boolean | null;
  isPharmacyEnabled?: boolean | null;
}

const NO_ADD_ONS: HospitalAddOns = { ipd: false, pharmacy: false };

/**
 * Paid add-ons the signed-in hospital holds. The server enforces them; this only
 * drives what the client shows. Values come from the hospital record loaded at login.
 */
@Injectable({ providedIn: 'root' })
export class HospitalAddOnService {
  readonly addOns$: Observable<HospitalAddOns>;
  private _current: HospitalAddOns = NO_ADD_ONS;

  constructor(private _hospitalState: HospitalStateService) {
    this.addOns$ = this._hospitalState.hospital$.pipe(
      map((hospital: HospitalAddOnSource | null) => this.toAddOns(hospital))
    );
    this.addOns$.subscribe(addOns => {
      this._current = addOns;
    });
  }

  get isIpdEnabled$(): Observable<boolean> {
    return this.addOns$.pipe(map(addOns => addOns.ipd));
  }

  get isPharmacyEnabled$(): Observable<boolean> {
    return this.addOns$.pipe(map(addOns => addOns.pharmacy));
  }

  get isIpdEnabled(): boolean {
    return this._current.ipd;
  }

  get isPharmacyEnabled(): boolean {
    return this._current.pharmacy;
  }

  private toAddOns(hospital: HospitalAddOnSource | null): HospitalAddOns {
    if (!hospital) {
      return NO_ADD_ONS;
    }

    return { ipd: !!hospital.isIPD, pharmacy: !!hospital.isPharmacyEnabled };
  }
}
